import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';

@Component({
    selector: 'open-prepays',
    templateUrl: 'open-prepays.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MaterialModule
    ],
})

export class OpenPrepaysComponent {
    prepays: any;
    message: string;
    Error: string;
    NameDescription: string;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        if (Array.isArray(data)) {
            data.forEach(element => {

                if (element.PrepaymentType == 0) {
                    element.ItemNumber = element.PrepaymentTypeDV;
                    if (element.PartialItemDescription != undefined && element.PartialItemDescription != null && element.PartialItemDescription != "") {
                        element.ItemNumber = element.ItemNumber + ':' + element.PartialItemDescription;
                    }
                }
                else if (element.PrepaymentType == 1) {
                    element.ItemNumber = element.PrepaymentTypeDV;
                    if (element.ItemNumberDV != undefined && element.ItemNumberDV != null && element.ItemNumberDV != "") {
                        element.ItemNumber = element.ItemNumber + ':' + element.ItemNumberDV;
                    }

                }
                else if (element.PrepaymentType == 3) {

                    element.ItemNumber = element.PrepaymentTypeDV;
                    if (element.ProductCategoryDV != undefined && element.ProductCategoryDV != null && element.ProductCategoryDV != "") {
                        element.ItemNumber = element.ItemNumber + ':' + element.ProductCategoryDV;
                    }
                }
                else {

                    element.ItemNumber = element.PrepaymentTypeDV;
                    if (element.PrepaymentReference != undefined && element.PrepaymentReference != null && element.PrepaymentReference != "") {
                        if (element.PrepaymentReference.length > 6) {
                            let locationCode = element.PrepaymentReference.substring(0, 3);
                            let ItemNumber = element.PrepaymentReference.substring(3);
                            element.PrepaymentReference = locationCode + "-" + ItemNumber;
                        }
                        element.ItemNumber = element.ItemNumber + ':' + element.PrepaymentReference;
                    }

                }
            });
            this.prepays = data;
            this.NameDescription = data["NameDescription"];
        }
        else {
            this.NameDescription = data["NameDescription"];
            this.Error = data["Message"];
        }
    }
}